// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/Giovanny Roman/AppData/Roaming/npm/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Left_Title{\r\n\tfont-size: 5.5rem;\r\n    color: #3dafff;\r\n    font-family: \"Montserrat\";\r\n    margin-bottom: 0rem;\r\n}\r\n.Right_Title{\r\n\tfont-size: 5.5rem;\r\n    color: white;\r\n    font-family: \"Montserrat\";\r\n    margin-bottom: 0rem;\r\n}\r\n.TitleContainerStyle{\r\n\tdisplay: flex;\r\n\t/* flex-direction: row; */\r\n\t/* justify-content: flex-start; */\r\n}", ""]);
// Exports
module.exports = exports;
